import { ResumeAward } from 'lib/redux/types';
import React from 'react'
import { TemplateSevenResumeSection, TemplateSevenResumeSectionWithSubsections } from './common';
import { View } from '@react-pdf/renderer';
import { spacing, styles } from '../ResumePDF/styles';
import { ResumePDFDescription, ResumePDFText } from '../ResumePDF/common';

const Award = ({
    heading,
    awards,
    themeColor,
    isPDF,
    enableHighlight = false,
    enableMistakeHighlight = false,
  }: {
    heading: string;
    awards: ResumeAward[];
    themeColor: string;
    isPDF: boolean;
    enableHighlight?: boolean;
    enableMistakeHighlight?: boolean;
  }) => {
  return (
    <TemplateSevenResumeSectionWithSubsections themeColor={themeColor} heading={heading}>
{
  awards.map(({award,issuer,descriptions},idx)=>(
    <View 
    key={idx} wrap={false}
    >
      <View  style={{
              ...styles.flexRowBetween,
              marginTop: spacing["0.5"],
            }}>
              <View   style={{
                ...styles.flexRow,
                gap: spacing["2"],
              }}>
                  <ResumePDFText bold={true}>{award}</ResumePDFText>-
                  <ResumePDFText italic={true}>{issuer}</ResumePDFText>


              </View>

      </View>
      <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
      <ResumePDFDescription 
        items={descriptions} 
        enableHighlight={enableHighlight}
        enableMistakeHighlight={enableMistakeHighlight}
        section="awards"
        itemIndex={idx}
      />
      </View>

    </View>
  ))
}

    </TemplateSevenResumeSectionWithSubsections>
  )
}

export default Award
